export default __webpack_public_path__ + "static/media/boxy.1495c3f3.webp";